export default __webpack_public_path__ + "static/media/home-icon.315189d1.webp";